import { render } from "./FoodMenuTestContainer.vue?vue&type=template&id=06ebc921&scoped=true&ts=true"
import script from "./FoodMenuTestContainer.vue?vue&type=script&lang=ts"
export * from "./FoodMenuTestContainer.vue?vue&type=script&lang=ts"

import "./FoodMenuTestContainer.vue?vue&type=style&index=0&id=06ebc921&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ebc921"]])

export default __exports__